import type { FormEventHandler } from 'react'
import { useState } from 'react'

import SaveIcon from '@mui/icons-material/Save'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import type { DisciplineVerzameling } from '@models/DisciplineVerzameling'
import { geschovenNaarAannemerWijzigbareDisciplines } from '@util/project-util'

import { useAuthenticatedUser } from '../../../../auth/hooks/useAuthenticatedUser'
import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { HoofdleidingProject } from '../../types/HoofdleidingProject'

import { GeschovenNaarAannemer } from './GeschovenNaarAannemer'

type Props = {
  project: HoofdleidingProject
  handleClose: () => void
}

export const WijzigenGeschovenNaarAannemer = ({
  project,
  handleClose,
}: Props) => {
  const { organisatie } = useAuthenticatedUser()
  const { mutate: saveEvent } = useSaveEvent()

  const [disciplines, setDisciplines] = useState(
    geschovenNaarAannemerWijzigbareDisciplines(project, organisatie),
  )

  const handleDisciplineUpdate = ({
    disciplineCode,
    netbeheerderCode,
    isGeschovenNaarAannemer,
  }: DisciplineVerzameling) => {
    setDisciplines((disciplines) =>
      disciplines.map((d) => {
        if (
          d.disciplineCode === disciplineCode &&
          d.netbeheerderCode === netbeheerderCode
        ) {
          return {
            ...d,
            isGeschovenNaarAannemer,
          }
        }

        return d
      }),
    )
  }

  const onSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault()

    saveEvent(
      {
        id: project.aanvraagID,
        type: 'wijzigen_geschoven_naar_aannemer',
        source: 'manual',
        data: {
          disciplineVerzamelingen: disciplines,
        },
      },
      { onSuccess: () => handleClose() },
    )
  }

  return (
    <form onSubmit={onSubmit}>
      <DialogTitle>Wijzigen geschoven naar aannemer</DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Hier kun je aangeven of een discipline is geschoven naar de aannemer.
        </DialogContentText>
        <GeschovenNaarAannemer
          disciplines={disciplines}
          handleDisciplineUpdate={handleDisciplineUpdate}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Annuleren
        </Button>

        <Button type="submit" variant="contained" startIcon={<SaveIcon />}>
          Opslaan
        </Button>
      </DialogActions>
    </form>
  )
}
